import React, { useMemo } from 'react'
import { BotMitigationDataStyled } from './BotMitigationData.styled'
import { useGetBotMitigationData } from 'Features/home/api/getBotMitigationData'
import { toUnixDateRangeFix } from 'Utils/dates'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { kFormatter } from 'Utils/number'
import { TotalVisits } from '../Components/TotalVisits/TotalVisits'
import { InvalidRequests } from '../Components/InvalidRequests/InvalidRequests'
import { ThreatGroupsBm } from '../Components/ThreatGroupsBm/ThreatGroupsBm'

export const BotMitigationData = () => {
  const { timezoneCountry } = useUserStore()
  const { data: plansDetails } = useGetPlansDetails()

  const serverDateConversion = toUnixDateRangeFix(timezoneCountry, {
    from: new Date(plansDetails?.currentPeriodStart || ''),
    to: new Date(),
  })
  const { data: rawData } = useGetBotMitigationData({
    startDate: serverDateConversion?.from || 0,
    endDate: serverDateConversion?.to || 0,
  })

  const bmData = useMemo(() => {
    let invalidRateSum = 0

    const data = {
      validVisits: 0,
      invalidRateAvg: '',
    }
    rawData?.summary.summary?.forEach((item) => {
      data.validVisits += item?.totalVisits
      invalidRateSum += item?.invalidRate
    })

    data.invalidRateAvg = (invalidRateSum / (rawData?.summary?.summary?.length || 1)).toFixed(2)

    return data
  }, [rawData])

  return (
    <BotMitigationDataStyled>
      <TotalVisits totalVisits={kFormatter(bmData.validVisits)} />
      <InvalidRequests invalidRequests={`${bmData.invalidRateAvg}%`} />
      <ThreatGroupsBm />
    </BotMitigationDataStyled>
  )
}
